import React from "react";
import { fetchWrapper } from "utils/apiFetch";

const PanCardDocumentsModal = ({ isOpen, onClose, data, refresh }) => {
  const role = localStorage.getItem("role");
  console.log(localStorage.getItem("role"));

  const isAdminUser = ["Admin", "Main Admin", "White label", "Pancard Agent"].includes(role);
  console.log(isAdminUser);
  if (!isOpen || !data) return null;

  const baseUrl = "https://pro.mokshiq.in/media/";
  const changeStatus = async (status) => {
    const formData = new FormData();
    formData.append("action", "change_status");
    formData.append("pid", data.pid);
    formData.append("status", status);
  
    await fetchWrapper("https://pro.mokshiq.in/pan_action_manager", {
      method: "POST",
      body: formData,
    });
  
    refresh();
    onClose();
  };
  const uploadSlip = async (file) => {
    const formData = new FormData();
    formData.append("action", "upload_slip");
    formData.append("pid", data.pid);
    formData.append("slip_image", file);
    formData.append("status", "Successfully Completed")
  
    await fetchWrapper("https://pro.mokshiq.in/pan_action_manager", {
      method: "POST",
      body: formData,
    });
  
    refresh();
    onClose();
  };
  
  
  const docs = [
    { label: "Photo", key: "photo" },
    { label: "Signature", key: "signature" },
    { label: "PAN Form Front", key: "panformfront" },
    { label: "PAN Form Back", key: "panformback" },
    { label: "Aadhar Front", key: "aadharfront" },
    { label: "Aadhar Back", key: "aadharback" },
    { label: "Document 1", key: "doc1" },
    { label: "Document 2", key: "doc2" },
  ];

  // ✅ Slip only when status = Created
  if (data.status?.toLowerCase() === "created") {
    docs.push({ label: "Slip", key: "slip" });
  }

  return (
    <div className="modal fade show d-block" style={{ background: "rgba(0,0,0,.6)" }}>
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">

          <div className="modal-header">
            <h5 className="modal-title">PAN Card Documents</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>

          <div className="modal-body">
            <div className="row g-3">
              {docs.map(({ label, key }) =>
                data[key] ? (
                  <div className="col-md-6" key={key}>
                    <div className="border p-2 rounded text-center">
                      <p className="fw-semibold mb-1">{label}</p>
                      <img
                        src={`${baseUrl}${data[key]}`}
                        alt={label}
                        className="img-fluid rounded"
                        style={{ maxHeight: "220px" }}
                      />
                    </div>
                  </div>
                ) : null
              )}
            </div>
            {isAdminUser && (
  <div className="modal-footer">

    {/* INITIATED → ACCEPT / REJECT */}
    {data.status?.toLowerCase() === "initiated" && (
      <>
        <button
          className="btn btn-success"
          onClick={() => changeStatus("accepted")}
        >
          Accept
        </button>

        <button
          className="btn btn-danger"
          onClick={() => changeStatus("rejected")}
        >
          Reject
        </button>
      </>
    )}

    {/* ACCEPTED → UPLOAD SLIP */}
    {data.status?.toLowerCase() === "accepted" && (
      <label className="btn btn-primary mb-0">
        Upload Slip
        <input
          type="file"
          hidden
          accept="image/*"
          onChange={(e) => uploadSlip(e.target.files[0])}
        />
      </label>
    )}

   
  </div>
)}

          </div>

          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>
              Close
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default PanCardDocumentsModal;
